module.exports = __webpack_public_path__ + "static/media/savermiddleeast-logo.89915664.svg";